module.exports = __webpack_public_path__ + "static/team2025-99bd183d0788b852eb6da9a31d4dcbd2.jpeg";